import {useState, useEffect} from 'react'

const AddUser = ({language, users, setUsers, profileId, isVisible, setIsVisible}) => {
    const [editorName, setEditorName] = useState('')
    const [editorEmail, setEditorEmail] = useState('')
    const [editorPwd, setEditorPwd] = useState('')
    const [editorPwd2, setEditorPwd2] = useState('')
    const [strengthBadge, setStrengthBadge] = useState('')
    const [passwordError, setPasswordError] = useState(false)
    const [editorNameError, setEditorNameError] = useState(false)
    const [editorEmailError, setEditorEmailError] = useState(false)
    

    useEffect(() => {
        setEditorName('')
        setEditorEmail('')
        setEditorPwd('')
        setEditorPwd2('')
        setStrengthBadge('')
        setPasswordError(false)
        setEditorNameError(false)
        setEditorEmailError(false)
    },[isVisible])

    const handleClose = async e => {
        e.preventDefault();
        setEditorName('')
        setEditorEmail('')
        setEditorPwd('')
        setEditorPwd2('')
        setStrengthBadge('')
        setIsVisible(isVisible ? false : true)
    }

    const handlePasswordChanged = e => {
        setEditorPwd(e.target.value)
        validatePwd(e)
        setPasswordError(editorPwd2 !== e.target.value && editorPwd2 !== '')
    }
    const handlePassword2Changed = e => {
        setEditorPwd2(e.target.value)
        setPasswordError(editorPwd !== e.target.value && editorPwd !== '')
    }

    const validatePwd = e=>{
        let password = e.target.value
        let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{10,})')
        let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{10,}))')

        if(strongPassword.test(password)) {
            setStrengthBadge('Strong')
        } else if(mediumPassword.test(password)) {
            setStrengthBadge('Medium')
        } else {
            setStrengthBadge('Weak')
        }
        if(password === ''){
            setStrengthBadge('');
        }
    }

    const addEditor = async () => {
        console.log(editorPwd)
        let error = false
        setEditorNameError(false)
        setEditorEmailError(false)
        if(editorName === ""){
            setEditorNameError(true)
            error = true
        }
        if(editorEmail === "" || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editorEmail))){
            setEditorEmailError(true)
            error = true
        }
        if(strengthBadge === 'Weak'){
            error = true
        }
        if(passwordError){error = true}
        if(!error){
            var graphql = JSON.stringify({
                query: `mutation( $editorName: String, $editorEmail: String, $editorPwd: String, $profileId: Long) {
                            addEditor( editorName: $editorName, editorEmail: $editorEmail, editorPwd: $editorPwd, profileId: $profileId) {
                                id
                                editorName
                                editorEmail
                                editorPwd
                                profileId
                            }
                        }`,
                variables: {
                    "editorName": editorName
                    , "editorEmail": editorEmail
                    , "editorPwd": editorPwd
                    , "profileId": profileId
                }
            })
            const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
                method:'POST',
                headers:{
                    'Authorization':'Basic ' + global.config.Editor.authToken
                    ,'Content-Type': 'application/json'
                },
                body: graphql
            })
            .then(response => response.text())
            .then(result => {
                setEditorPwd()
                setEditorPwd2()
                const resData = JSON.parse(result).data
                setUsers(...users, resData.addEditor)
                handleClose()
                return resData

            })
            .catch(error => console.log('error', error))
            const data = await res
            return data
        }
    }

    return (
        <>
        {(isVisible) && <div id="cc_overlay"></div>}
        <div id="cc_editarticle" className={isVisible ? '' : 'hidden'} >
            <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Tilføj ny Bruger' : 'Add new User'}</h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>
                        <input type="text" name="editorName" className={(editorNameError) && 'input-error'} value={editorName} onChange={ e => setEditorName(e.target.value)} autoComplete="off"/>
                    </label>
                    <label className="input_label">
                        <span>Email</span>
                        <input type="text" name="editorEmail" className={(editorEmailError) && 'input-error'} value={editorEmail} onChange={ e => setEditorEmail(e.target.value)} autoComplete="off"/>
                    </label>
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Adgangskode' : 'Password'}</span>
                        <input type="password" name="editorPwd" className={(strengthBadge === 'Weak') && 'input-error'} value={editorPwd} onChange={handlePasswordChanged} autoComplete="off"/>
                    </label>
                    {(strengthBadge) && 
                    <label>
                        {(strengthBadge === 'Weak') && <span className="cc_user_password_strength weak">{language.value === 'DA' ? 'Svag adgangskode' : 'Weak Password'}</span>}
                        {(strengthBadge === 'Medium') && <span className="cc_user_password_strength medium">{language.value === 'DA' ? 'Medium Adgangskode' : 'Medium Password'}</span>}
                        {(strengthBadge === 'Strong') && <span className="cc_user_password_strength strong">{language.value === 'DA' ? 'Stærk Adgangskode' : 'Strong Password'}</span>}
                    </label>
                    }
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Gentag Adgangskode' : 'Confirm Password'}</span>
                        <input type="password" name="editorPwd2" className={(passwordError) && 'input-error'} value={editorPwd2} onChange={handlePassword2Changed} autoComplete="off"/>
                    </label>
                    {(passwordError) && <i className="sprite-icon icon-close"></i>}
                </div>
                <div className="cc_password_requirements">
                {(language.value === 'DA') &&
                <>
                    <b>
                        Krav til adgangskoden:
                    </b>
                    <ul>
                        <li>mindst et lille bogstav (a-z)</li>
                        <li>mindst et stort bogstav (A-Z)</li>
                        <li>mindst et ciffer (0-9)</li>
                        <li>mindst et specialtegn (?!#&%)</li>
                        <li>og skal være på mindst otte tegn</li>
                    </ul>
                </>
                }
                
                {(language.value !== 'DA') &&
                <>
                    <b>
                        Password requirements:
                    </b>
                    <ul>
                        <li>at least one lowercase letter (a-z)</li>
                        <li>at least one uppercase letter (A-Z)</li>
                        <li>at least one digit (0-9)</li>
                        <li>at least one special character (?! # &%)</li>
                        <li>and must be at least eight characters long</li>
                    </ul>
                    </>
                }
                </div>
                <div className="align_right">
                        <button onClick={addEditor} className="cc-btn blue-gradient">{language.value === 'DA' ? 'OPRET BRUGER' : 'CREATE USER'}</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default AddUser
